export default {
  name: 'stickerSignup',
  components: {},
  mixins: [],
  props: [],
  data() {
    return {
      tallestStepHeight: 100,
      stepOne: true,
      email: '',
      first_name: '',
      last_name: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      anyError: '',
      emailError: '',
      firstNameError: '',
      lastNameError: '',
      addressError: '',
      cityError: '',
      stateError: '',
      zipError: '',
      formSubmitted: false, // Track if the form has been submitted
      validSubmit: false, // Track if the form has been successfully submitted
    };
  },
  methods: {
    tallestStep() {
      const elements = document.querySelectorAll('.modal-step');

      elements.forEach((element) => {
        const height = element.clientHeight;
        this.tallestStepHeight = Math.max(this.tallestStepHeight, height);
      });

      console.log('Tallest Height:', this.tallestStepHeight);
    },
    stickerSubmit() {
      // Set formSubmitted to true to trigger validation
      this.formSubmitted = true;

      if (this.isFormValid) {
        // Form submission logic
        console.log('Form submitted with email:', this.email);

        // Get the form data
        exponea.identify(
          {
            email_id: this.email,
          },
          {
            source: 'sticker',
            email: this.email,
            first_name: this.first_name,
            last_name: this.last_name,
            address: this.address,
            city: this.city,
            state: this.state,
            zip: this.zip,
          }
        );

        exponea.track('consent', {
          action: 'accept',
          category: 'Email Marketing',
          valid_until: 'unlimited',
        });

        exponea.track('sticker-signup', {
          source: 'sticker',
        });

        // Set submitted to true to display success message
        this.validSubmit = true;

        //Send to DUMAC
        axios
          .post(
            'https://production-access-api.cotopaxi.com/dumac/freeStickerRequest',
            {
              name: this.first_name + ' ' + this.last_name,
              address: this.address,
              city: this.city,
              state: this.state,
              zip: this.zip,
              email: this.email,
            }
          )
          .catch(
            (error) =>
              (this.anyError =
                'Oops! Something Went Wrong. Please Try Again Later')
          );

        //Dynamic Yield Sign up event
        let dynamicYieldEmail = DYO.dyhash.sha256(this.email.toLowerCase());

        //adding a newsletter specific send for DY - this should be used in conjunction with the sign up event above.
        DY.API('event', {
          name: 'Newsletter Subscription',
          properties: {
            dyType: 'newsletter-subscription-v1',
            hashedEmail: dynamicYieldEmail, // SHA256 encoding of the lowercase email.
            //phoneNumber:"+972503803434"
          },
        });
        //end Dynamic Yield signup event
      } else {
        this.anyError = 'Please fix the errors in the form.';
        // Handle form submission when invalid
        console.log('Form submission blocked due to validation errors.');
      }
    },
    validateEmail() {
      // Regular expression for email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.email) {
        this.emailError = 'Email is required.';
      } else if (!emailRegex.test(this.email)) {
        this.emailError = 'Invalid email format.';
      } else {
        this.emailError = '';
      }
    },
    validateFirstName() {
      if (!this.first_name) {
        this.firstNameError = 'First Name is required.';
      } else {
        this.firstNameError = '';
      }
    },
    validateLastName() {
      if (!this.last_name) {
        this.lastNameError = 'Last Name is required.';
      } else {
        this.lastNameError = '';
      }
    },
    validateAddress() {
      if (!this.address) {
        this.addressError = 'Address is required.';
      } else {
        this.addressError = '';
      }
    },
    validateState() {
      const stateRegex = /^[A-Z]{2}$/; // Two-letter state abbreviation validation

      if (!this.state) {
        this.stateError = 'State abbreviation is required.';
      } else if (!stateRegex.test(this.state)) {
        this.stateError =
          'Invalid state abbreviation format. Please enter two uppercase letters.';
      } else {
        this.stateError = '';
      }
    },
    validateCity() {
      if (!this.city) {
        this.cityError = 'City is required.';
      } else {
        this.cityError = '';
      }
    },
    validateZip() {
      const zipRegex = /^\d{5}$/; // Simple 5-digit zip code validation

      if (!this.zip) {
        this.zipError = 'Zip code is required.';
      } else if (!zipRegex.test(this.zip)) {
        this.zipError =
          'Invalid zip code format. Please enter a 5-digit number.';
      } else {
        this.zipError = '';
      }
    },
    nextStep() {
      this.validateEmail();
      if (this.emailError === '') {
        this.stepOne = false;
      }
    },
  },
  computed: {
    isFormValid() {
      this.validateEmail(); // Validate on form submission
      this.validateFirstName();
      this.validateLastName();
      this.validateAddress();
      this.validateCity();
      this.validateState();
      this.validateZip();
      //this.validatePhone();
      // Previous validation checks
      return this.email && !this.emailError &&
             this.first_name && !this.firstNameError &&
             this.last_name && !this.lastNameError &&
             this.address && !this.addressError &&
             this.city && !this.cityError &&
             this.zip && !this.zipError &&
             this.state && !this.stateError;
    },
  },
  mounted() {
    //set the height of the steps based on the tallest step
    this.tallestStep();
  },
};
